import UIHelper from "general/helpers/UIHelper";
import DriverReconciliationListView from "../../components/DriverReconciliationListView";
import useRouter from "hooks/useRouter";
import { useSelector } from "react-redux";

DriverReconciliationListScreen.propTypes = {};

function DriverReconciliationListScreen(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const { user } = useSelector(state => state.auth);
    const adminRole = user?.role === 'ADMIN' || user?.role === 'OPERATOR';

    return (
        <div>
            {/* breadcrumb */}
            <div>
                {adminRole && UIHelper.buildBreadcrumb([
                    {
                        title: 'Báo cáo đối soát DNVT',
                        onPress: () => {
                            router.navigate(-1);
                        },
                    },
                    { title: 'Đối soát tài xế doanh nghiệp' },
                ])}
            </div>
            <div className="container-fluid px-4 my-4">
                <DriverReconciliationListView />
            </div>
        </div>
    );
}

export default DriverReconciliationListScreen;
